unit View.Scripts_Aliados.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewScripts_AliadosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbscript_id: TLabel;
    edscript_id: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lberro: TLabel;
    ederro: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    XDataClientScripts_AliadosGet: TXDataWebClient;
    XDataClientScripts_AliadosDelete: TXDataWebClient;
    Scripts_AliadosDataset: TXDataWebDataSet;
    Scripts_AliadosDatasetid: TIntegerField;
    Scripts_AliadosDatasetscript_id: TIntegerField;
    Scripts_AliadosDatasetaliado_id: TIntegerField;
    Scripts_AliadosDatasetdata_base_id: TIntegerField;
    Scripts_AliadosDatasetstatus: TIntegerField;
    Scripts_AliadosDataseterro: TStringField;
    Scripts_AliadosDatasetinclusao: TDateTimeField;
    Scripts_AliadosDatasetalteracao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientScripts_AliadosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientScripts_AliadosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientScripts_AliadosDeleteError(Error: TXDataClientError);
    procedure Scripts_AliadosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewScripts_AliadosEdit: TFViewScripts_AliadosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewScripts_AliadosEdit }

procedure TFViewScripts_AliadosEdit.btSaveClick(Sender: TObject);
begin
  if Scripts_AliadosDataset.State in dsEditModes then
  begin
        Scripts_AliadosDataset.Post;
    Scripts_AliadosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewScripts_AliadosEdit.btDeleteClick(Sender: TObject);
begin
  if Scripts_AliadosDataset.State in dsEditModes then
    Scripts_AliadosDataset.Post;
  XDataClientScripts_AliadosDelete.Delete(Scripts_AliadosDataset.EntitySetName,
    TJSObject(Scripts_AliadosDataset.CurrentData));
end;


class function TFViewScripts_AliadosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewScripts_AliadosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewScripts_AliadosEdit.InsertEntity;
begin
  Scripts_AliadosDataset.Close;
  Scripts_AliadosDataset.SetJsonData('{}');
  Scripts_AliadosDataset.Open;
  Scripts_AliadosDataset.Insert;
end;

class function TFViewScripts_AliadosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewScripts_AliadosEdit(AForm).FInserting := AInserting;
    TFViewScripts_AliadosEdit(AForm).FId := AId;
    TFViewScripts_AliadosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewScripts_AliadosEdit(AForm).InsertEntity
    else
      TFViewScripts_AliadosEdit(AForm).LoadEntity;
    TFViewScripts_AliadosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewScripts_AliadosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewScripts_AliadosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Scripts_AliadosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Scripts_AliadosDataset.EntitySetName
    )
  );
  XDataClientScripts_AliadosGet.Get(Scripts_AliadosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewScripts_AliadosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewScripts_AliadosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewScripts_AliadosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewScripts_AliadosEdit.XDataClientScripts_AliadosGetLoad(Response: TXDataClientResponse);
begin
  Scripts_AliadosDataset.Close;
  Scripts_AliadosDataset.SetJsonData(Response.Result);
  Scripts_AliadosDataset.Open;
  
  Scripts_AliadosDataset.Edit;  
end;

procedure TFViewScripts_AliadosEdit.XDataClientScripts_AliadosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewScripts_AliadosEdit.XDataClientScripts_AliadosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewScripts_AliadosEdit.Scripts_AliadosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewScripts_AliadosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewScripts_AliadosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.scripts_aliados.form.message');
  lbMessage := TLabel.Create('view.scripts_aliados.form.message.label');
  btCloseMessage := TButton.Create('view.scripts_aliados.form.message.button');
  btCancel := TButton.Create('view.scripts_aliados.form.btBack');
  btSave := TButton.Create('view.scripts_aliados.form.btSave');
  btDelete := TButton.Create('view.scripts_aliados.form.btDelete');
  lbid := TLabel.Create('view.scripts_aliados.form.lbid');
  edid := TDBEdit.Create('view.scripts_aliados.form.edid');
  lbscript_id := TLabel.Create('view.scripts_aliados.form.lbscript_id');
  edscript_id := TDBEdit.Create('view.scripts_aliados.form.edscript_id');
  lbaliado_id := TLabel.Create('view.scripts_aliados.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.scripts_aliados.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.scripts_aliados.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.scripts_aliados.form.eddata_base_id');
  lbstatus := TLabel.Create('view.scripts_aliados.form.lbstatus');
  edstatus := TDBEdit.Create('view.scripts_aliados.form.edstatus');
  lberro := TLabel.Create('view.scripts_aliados.form.lberro');
  ederro := TDBEdit.Create('view.scripts_aliados.form.ederro');
  lbinclusao := TLabel.Create('view.scripts_aliados.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.scripts_aliados.form.edinclusao');
  lbalteracao := TLabel.Create('view.scripts_aliados.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.scripts_aliados.form.edalteracao');
  DataSource := TDataSource.Create(Self);
  Scripts_AliadosDataset := TXDataWebDataSet.Create(Self);
  Scripts_AliadosDatasetid := TIntegerField.Create(Self);
  Scripts_AliadosDatasetscript_id := TIntegerField.Create(Self);
  Scripts_AliadosDatasetaliado_id := TIntegerField.Create(Self);
  Scripts_AliadosDatasetdata_base_id := TIntegerField.Create(Self);
  Scripts_AliadosDatasetstatus := TIntegerField.Create(Self);
  Scripts_AliadosDataseterro := TStringField.Create(Self);
  Scripts_AliadosDatasetinclusao := TDateTimeField.Create(Self);
  Scripts_AliadosDatasetalteracao := TDateTimeField.Create(Self);
  XDataClientScripts_AliadosGet := TXDataWebClient.Create(Self);
  XDataClientScripts_AliadosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbscript_id.BeforeLoadDFMValues;
  edscript_id.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  lberro.BeforeLoadDFMValues;
  ederro.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Scripts_AliadosDataset.BeforeLoadDFMValues;
  Scripts_AliadosDatasetid.BeforeLoadDFMValues;
  Scripts_AliadosDatasetscript_id.BeforeLoadDFMValues;
  Scripts_AliadosDatasetaliado_id.BeforeLoadDFMValues;
  Scripts_AliadosDatasetdata_base_id.BeforeLoadDFMValues;
  Scripts_AliadosDatasetstatus.BeforeLoadDFMValues;
  Scripts_AliadosDataseterro.BeforeLoadDFMValues;
  Scripts_AliadosDatasetinclusao.BeforeLoadDFMValues;
  Scripts_AliadosDatasetalteracao.BeforeLoadDFMValues;
  XDataClientScripts_AliadosGet.BeforeLoadDFMValues;
  XDataClientScripts_AliadosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewScripts_AliadosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 481;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 421;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 421;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 421;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbscript_id.SetParentComponent(Self);
    lbscript_id.Name := 'lbscript_id';
    lbscript_id.Left := 24;
    lbscript_id.Top := 219;
    lbscript_id.Width := 14;
    lbscript_id.Height := 13;
    lbscript_id.Caption := 'script_id:';
    lbscript_id.Transparent := True;
    edscript_id.SetParentComponent(Self);
    edscript_id.Name := 'edscript_id';
    edscript_id.Left := 221;
    edscript_id.Top := 216;
    edscript_id.Width := 200;
    edscript_id.Height := 21;
    edscript_id.Enabled := True;
    edscript_id.TabOrder := 7;
    edscript_id.Text := 'edscript_id';
    edscript_id.DataField := 'script_id';
    edscript_id.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 246;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 243;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 8;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 273;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 270;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 9;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 24;
    lbstatus.Top := 300;
    lbstatus.Width := 14;
    lbstatus.Height := 13;
    lbstatus.Caption := 'status:';
    lbstatus.Transparent := True;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 221;
    edstatus.Top := 297;
    edstatus.Width := 200;
    edstatus.Height := 21;
    edstatus.Enabled := True;
    edstatus.TabOrder := 10;
    edstatus.Text := 'edstatus';
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    lberro.SetParentComponent(Self);
    lberro.Name := 'lberro';
    lberro.Left := 24;
    lberro.Top := 327;
    lberro.Width := 14;
    lberro.Height := 13;
    lberro.Caption := 'erro:';
    lberro.Transparent := True;
    ederro.SetParentComponent(Self);
    ederro.Name := 'ederro';
    ederro.Left := 221;
    ederro.Top := 324;
    ederro.Width := 200;
    ederro.Height := 21;
    ederro.Enabled := True;
    ederro.TabOrder := 11;
    ederro.Text := 'ederro';
    ederro.DataField := 'erro';
    ederro.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 354;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 351;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 12;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 381;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 378;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 13;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Scripts_AliadosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Scripts_AliadosDataset.SetParentComponent(Self);
    Scripts_AliadosDataset.Name := 'Scripts_AliadosDataset';
    Scripts_AliadosDataset.AfterApplyUpdates := Scripts_AliadosDatasetAfterApplyUpdates;
    Scripts_AliadosDataset.EntitySetName := 'Scripts_Aliados';
    Scripts_AliadosDataset.Connection := DMConnection.ApiConnection;
    Scripts_AliadosDataset.Left := 176;
    Scripts_AliadosDataset.Top := 8;
    Scripts_AliadosDatasetid.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetid.Name := 'Scripts_AliadosDatasetid';
    Scripts_AliadosDatasetid.FieldName := 'id';
    Scripts_AliadosDatasetid.Required := True;
    Scripts_AliadosDatasetscript_id.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetscript_id.Name := 'Scripts_AliadosDatasetscript_id';
    Scripts_AliadosDatasetscript_id.FieldName := 'script_id';
    Scripts_AliadosDatasetscript_id.Required := True;
    Scripts_AliadosDatasetaliado_id.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetaliado_id.Name := 'Scripts_AliadosDatasetaliado_id';
    Scripts_AliadosDatasetaliado_id.FieldName := 'aliado_id';
    Scripts_AliadosDatasetaliado_id.Required := True;
    Scripts_AliadosDatasetdata_base_id.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetdata_base_id.Name := 'Scripts_AliadosDatasetdata_base_id';
    Scripts_AliadosDatasetdata_base_id.FieldName := 'data_base_id';
    Scripts_AliadosDatasetdata_base_id.Required := True;
    Scripts_AliadosDatasetstatus.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetstatus.Name := 'Scripts_AliadosDatasetstatus';
    Scripts_AliadosDatasetstatus.FieldName := 'status';
    Scripts_AliadosDatasetstatus.Required := True;
    Scripts_AliadosDataseterro.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDataseterro.Name := 'Scripts_AliadosDataseterro';
    Scripts_AliadosDataseterro.FieldName := 'erro';
    Scripts_AliadosDataseterro.Required := False;
    Scripts_AliadosDataseterro.Size := 255;
    Scripts_AliadosDatasetinclusao.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetinclusao.Name := 'Scripts_AliadosDatasetinclusao';
    Scripts_AliadosDatasetinclusao.FieldName := 'inclusao';
    Scripts_AliadosDatasetinclusao.Required := False;
    Scripts_AliadosDatasetalteracao.SetParentComponent(Scripts_AliadosDataset);
    Scripts_AliadosDatasetalteracao.Name := 'Scripts_AliadosDatasetalteracao';
    Scripts_AliadosDatasetalteracao.FieldName := 'alteracao';
    Scripts_AliadosDatasetalteracao.Required := False;
    XDataClientScripts_AliadosGet.SetParentComponent(Self);
    XDataClientScripts_AliadosGet.Name := 'XDataClientScripts_AliadosGet';
    XDataClientScripts_AliadosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientScripts_AliadosGet, Self, 'OnLoad', 'XDataClientScripts_AliadosGetLoad');
    XDataClientScripts_AliadosGet.Left := 64;
    XDataClientScripts_AliadosGet.Top := 8;
    XDataClientScripts_AliadosDelete.SetParentComponent(Self);
    XDataClientScripts_AliadosDelete.Name := 'XDataClientScripts_AliadosDelete';
    XDataClientScripts_AliadosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientScripts_AliadosDelete, Self, 'OnLoad', 'XDataClientScripts_AliadosDeleteLoad');
    SetEvent(XDataClientScripts_AliadosDelete, Self, 'OnError', 'XDataClientScripts_AliadosDeleteError');
    XDataClientScripts_AliadosDelete.Left := 64;
    XDataClientScripts_AliadosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbscript_id.AfterLoadDFMValues;
    edscript_id.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    lberro.AfterLoadDFMValues;
    ederro.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Scripts_AliadosDataset.AfterLoadDFMValues;
    Scripts_AliadosDatasetid.AfterLoadDFMValues;
    Scripts_AliadosDatasetscript_id.AfterLoadDFMValues;
    Scripts_AliadosDatasetaliado_id.AfterLoadDFMValues;
    Scripts_AliadosDatasetdata_base_id.AfterLoadDFMValues;
    Scripts_AliadosDatasetstatus.AfterLoadDFMValues;
    Scripts_AliadosDataseterro.AfterLoadDFMValues;
    Scripts_AliadosDatasetinclusao.AfterLoadDFMValues;
    Scripts_AliadosDatasetalteracao.AfterLoadDFMValues;
    XDataClientScripts_AliadosGet.AfterLoadDFMValues;
    XDataClientScripts_AliadosDelete.AfterLoadDFMValues;
  end;
end;

end.
